/* DmB product gallery (dmb layout) — dot indicators + variant→image scroll.
   Slick is disabled on this layout; the gallery is a plain stacked/scroll-snap
   track. variants.js still fires a click on the (hidden) thumbnail for the
   selected variant's media — we mirror that to scroll the main slide. */
(function () {
  'use strict';

  function init(root) {
    var track = root.querySelector('.productView-nav');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('.productView-image'));
    if (slides.length < 2) return;

    /* ---- dots (shown on mobile via CSS) ---- */
    var dots = document.createElement('div');
    dots.className = 'dmb-pdp__dots';
    slides.forEach(function (slide, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'dmb-pdp__dot' + (i === 0 ? ' is-active' : '');
      b.setAttribute('aria-label', 'Go to image ' + (i + 1));
      b.addEventListener('click', function () { scrollToSlide(slide); });
      dots.appendChild(b);
    });
    var host = root.querySelector('.halo-productView-left') || track.parentElement;
    host.appendChild(dots);
    var dotEls = Array.prototype.slice.call(dots.children);

    function setActive(i) {
      for (var j = 0; j < dotEls.length; j++) dotEls[j].classList.toggle('is-active', j === i);
    }
    function scrollToSlide(slide) {
      if (window.matchMedia('(max-width: 1024px)').matches) {
        /* scroll ONLY the track: scrollIntoView also scrolls ancestors (the page)
           and fights iOS mandatory snap mid-gesture */
        var sp = parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0;
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft - sp, behavior: 'smooth' });
      } else {
        slide.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    /* active-dot sync while the carousel scrolls (mobile) */
    try {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio >= 0.5) {
            var idx = slides.indexOf(e.target);
            if (idx > -1) setActive(idx);
          }
        });
      }, { root: track, threshold: 0.5 });
      slides.forEach(function (s) { io.observe(s); });
    } catch (err) { /* IO unsupported: dots still clickable */ }

    /* ---- variant → image: variants.js clicks the hidden thumbnail
       [data-media-id="{section}-{mediaId}"]; scroll the matching main slide ---- */
    root.querySelectorAll('.productView-thumbnail[data-media-id]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var raw = thumb.getAttribute('data-media-id') || '';
        var mediaId = raw.split('-').pop();
        var main = root.querySelector('.product-single__media[data-media-id="' + mediaId + '"]');
        var slide = main && main.closest ? main.closest('.productView-image') : null;
        if (slide) scrollToSlide(slide);
      });
    });
  }

  /* collapse all PDP accordion tabs on load (Product Details should not be open initially) */
  function collapseTabs() {
    document.querySelectorAll('.dmb-pdp .productView-tab .toggle-content.is-active, .dmb-pdp .productView-tab .tab-content.is-active').forEach(function (e) { e.classList.remove('is-active'); });
    document.querySelectorAll('.dmb-pdp .productView-tab .toggle-content.is-open, .dmb-pdp .productView-tab .tab-title.is-open, .dmb-pdp .productView-tab .toggleLink.is-open').forEach(function (e) { e.classList.remove('is-open'); });
  }

  /* hide empty zero-height panel blocks so they don't each eat a gap before As Seen On */
  function hideEmptyPanelItems() {
    document.querySelectorAll('.dmb-pdp .productView-product > .productView-moreItem, .dmb-pdp .productView-product > .shopify-block').forEach(function (mi) {
      if (mi.offsetHeight !== 0) return;
      if (mi.textContent.trim() === '' && !mi.querySelector('img,svg,input,button,select,textarea,iframe')) {
        mi.style.display = 'none';
      } else {
        // zero-height block that still holds a (hidden) form — collapse its gap
        mi.style.setProperty('margin-top', '0', 'important');
        mi.style.setProperty('margin-bottom', '0', 'important');
      }
    });
  }

  /* (desktop panel overflow handled in pure CSS: the sticky right panel max-heights to
     the viewport and scrolls internally — see .halo-productView-right in dmb-product.css) */

  function boot() { document.querySelectorAll('.dmb-pdp').forEach(init); collapseTabs(); hideEmptyPanelItems(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
